import { useState, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './basicInfo.module.scss';
import { TextField, MenuItem } from '@mui/material';
import { TRANSMISSION_TYPES, TYPE_TYPES } from '../../../constants/salePost';
import { FUEL_TYPES, COLORS } from '../../../constants/Publication';
import { optionsAccidentsReported, optionsPersonalUse, optionsSoleOwner } from '../../../constants/app';
import { BasicInfoProps } from '../../../interfaces/salePost';
import { capitalize, getYears, formatInput, addPointsInText } from "../../../helpers/app";
import Button from "../../../components/Button";
import FeaturesList from '../FeaturesModal/FeaturesList';
import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { images } from '../../../constants/images';

const selectProps = {
    MenuProps: {
        PaperProps: {
            style: { maxHeight: 200 }
        },
        anchorOrigin: {
            vertical: "bottom" as const,
            horizontal: "left" as const
        },
        transformOrigin: {
            vertical: "top" as const,
            horizontal: "left" as const
        }
    }
};

const sxTextFieldDefault = {
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'black',
      },
      '&:hover fieldset': {
        borderColor: 'black',
      },
    },
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: 'black',
      },
    },
  };
  

const DOORS_OPTIONS = [
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
];

const REGION_NAMES = [
    { id: 1, name: "Antofagasta" },
    { id: 2, name: "Arica y Parinacota" },
    { id: 3, name: "Atacama" },
    { id: 4, name: "Coquimbo" },
    { id: 5, name: "Región de Aisen del Gral. Carlos Ibañez del Campo" },
    { id: 6, name: "Región de la Araucania" },
    { id: 7, name: "Región de los lagos" },
    { id: 8, name: "Región de los rios" },
    { id: 9, name: "Región de Magallanes y de la Antartica Chilena" },
    { id: 10, name: "Región del Biobio" },
    { id: 11, name: "Región del libertador Gral. Bernardo O'Higgins" },
    { id: 12, name: "Región del Maule" },
    { id: 13, name: "Región Metropolitana de Santiago" },
    { id: 14, name: "Tarapaca" },
    { id: 15, name: "Valparaiso" }
];


const BasicInfo = ({
    isPatentFound,
    initialData,
    onContinue,
    color,
    fuel,
    version,
    versions,
    getVersions,
    fetchingVersions,
    setVersion,
    setFuel,
    setYear,
    setColor,
    models,
    year,
    plate,
    vehicleType,
    setType,
    transmission,
    setTransmission,
    getBrands,
    cleanGetBrands,
    setBrand,
    getModels,
    cleanGetModels,
    setModel,
    doors,
    setDoors,
    brands,
    isFoundPlate,
    kms,
    setKms,
    soleOwner,
    personalUse,
    accidentsReported,
    getSuggestedPrice,
    setRecord,
    request_id,
    features,
    setFeatures,
    cleanGetVersions,
    additionalCharacters,
    getAdditionalCharacters,
    setAdditionalCharacters,
    setSelectedAdditionalCharacters,
    selectedAdditionalCharacters,
    setRegion,
    region,
    regions,
    getRegions,
    onValidityChange
}: BasicInfoProps) => {
    const location = useLocation();
    const [hasInitialized, setHasInitialized] = useState(false);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [colorSelected, setColorSelected] = useState(isPatentFound && initialData?.color ? initialData.color : "");
    const [fuelSelected, setFuelSelected] = useState<string>(isPatentFound && initialData?.fuel ? initialData.fuel : "");
    const [typeSelected, setTypeSelected] = useState<string>(isPatentFound && initialData?.vehicle_type ? initialData.vehicle_type : '');
    const [transmissionSelected, setTransmissionSelected] = useState<string>(isPatentFound && (initialData?.transmission || transmission) ? (initialData?.transmission || transmission) : '');
    const [doorsSelected, setDoorsSelected] = useState<string>(isPatentFound ? (doors || 5).toString() : '');
    const [versionSelected, setVersionSelected] = useState<any>(isPatentFound && version ? { id: version.id, name: version.name } : { id: null, name: null });
    const [modelSelected, setModelSelected] = useState<any>(isPatentFound && initialData ? { id: initialData.model_id || null, name: initialData.model_name || null } : { id: null, name: null });
    const [brandSelected, setBrandSelected] = useState<any>(isPatentFound && initialData ? { id: initialData.brand_id || null, name: initialData.brand_name || null } : { id: null, name: null });
    const [accidentsReportedState, setAccidentsReported] = useState<any>({ value: accidentsReported || "", error: "" });
    const [personalUseState, setPersonalUse] = useState<any>({ value: personalUse || "", error: "" });
    const [soleOwnerState, setSoleOwner] = useState<any>({ value: soleOwner || "", error: "" });
    const [mileage, setMileage] = useState<any>({ value: "0", error: "" });
    const [unmatchedCarroceria, setUnmatchedCarroceria] = useState<string | null>(null);
    const [regionsData, setRegionsData] = useState<any[]>([]);
    const [regionSelected, setRegionSelected] = useState<string>("Región Metropolitana de Santiago");
    const [selectedFeatures, setSelectedFeatures] = useState<string[]>(features || []);
    const [disabledNewCar, setDisabledNewCar] = useState<boolean>(true);
    

    const yearsNormalized = useMemo(() => {
        const years = getYears(100);
        return years.map((year: number) => ({
            id: year,
            name: year
        }));
    }, []);


    useEffect(() => {
        if (getRegions) {
            getRegions()
        }
    }, [getRegions]);


    const customIconStyle = {
        width: 10,
        height: 10,
        border: '1px solid green',
        padding: 0.5,
        borderRadius: '50%',
        display: 'flex',
        marginRight: 2,
        alignItems: 'center',
        justifyContent: 'center'
    };
    const [formData, setFormData] = useState(isPatentFound && initialData ? {
        carroceria: initialData?.vehicle_type || '',
        año: initialData?.year?.toString() || '',
        añoInt: initialData?.year || null,  // Añadimos un campo para guardar el año como número
        marca: initialData?.brand_name || '',
        modelo: initialData?.model_name || '',
        version: version?.name || '',
        color: initialData?.color || '',
        transmision: '',
        combustible: '',
        kilometraje: '',
        unicoDueño: '',
        puertas: '',
        region: '',
    } : {
        carroceria: '',
        año: '',
        añoInt: null,
        marca: '',
        modelo: '',
        version: '',
        color: '',
        transmision: '',
        combustible: '',
        kilometraje: '',
        unicoDueño: '',
        puertas: '',
        region: ''
    });

    // Función para actualizar el kilometraje
    const onChangeMileage = (e: any) => {
        const value = e.target ? e.target.value : e;
        const { formattedNumber } = formatInput(value);
        const kmValue = formattedNumber.replace(/\./g, '');

        setMileage({ ...mileage, value: formattedNumber, error: "" });
        setFormData(prev => ({ ...prev, kilometraje: kmValue }));

        if (setKms) setKms(kmValue);
    }

    // Validación al perder el foco en el campo de kilometraje
    const onBlurMileage = () => {
        if (mileage?.value && parseInt(mileage.value.replace(/\./g, '')) === 0) {
            setMileage({ ...mileage, error: "No es posible publicar vehículos con 0 km" });
        } else {
            setMileage({ ...mileage, error: "" });
            if (setKms && mileage?.value) {
                setKms(mileage.value.replace(/\./g, ''));
            }
        }
    }

    // Función para actualizar el registro con todos los datos 
    const updateRecord = (field: string, value: string) => {
        if (setRecord) {
            // Convertir valores de string a booleanos según lo que espera el backend
            const accidentsReportedValue = field === 'accidentsReported' ? value : accidentsReportedState?.value || '';
            const personalUseValue = field === 'personalUse' ? value : personalUseState?.value || '';
            const soleOwnerValue = field === 'soleOwner' ? value : soleOwnerState?.value || '';

            const recordData = {
                // Convertir a booleanos según los valores esperados
                accidentsReported: accidentsReportedValue === 'Sin accidentes' ? false : true,
                personalUse: personalUseValue === 'Uso personal' ? true : false,
                soleOwner: soleOwnerValue === 'Si' || soleOwnerValue === 'Sí' ? true : false,

            };

            setRecord(recordData);
        }
    }

    // Funciones para manejar cambios en los campos de registro
    const onChangeAccidentsReported = (e: any) => {
        const value = e.target ? e.target.value : e;
        setAccidentsReported({ ...accidentsReportedState, value });
        setFormData(prev => ({ ...prev, accidentesReportados: value }));
        updateRecord('accidentsReported', value);
    }

    const onChangePersonalUse = (e: any) => {
        const value = e.target ? e.target.value : e;
        setPersonalUse({ ...personalUseState, value });
        setFormData(prev => ({ ...prev, usoPersonal: value }));
        updateRecord('personalUse', value);
    }

    const onChangeSoleOwner = (e: any) => {
        const value = e.target ? e.target.value : e;
        setSoleOwner({ ...soleOwnerState, value });
        setFormData(prev => ({ ...prev, unicoDueño: value }));
        updateRecord('soleOwner', value);
    }

    const handleChangeRegion = (event: any) => {
        const newRegion = event.target.value;
        setRegionSelected(newRegion);
        setRegion(newRegion);
        if (setRegion) {
            setRegion(newRegion); // Actualiza el estado global
        }
        setFormData(prev => ({ ...prev, region: newRegion }));
    };

    // Funciones para manejar cambios en los campos de selección
    const handleChangeVersion = (id: string) => {
        const parsedId = parseInt(id);
        if (parsedId === -1) {
            const other = { id: -1, name: "OTRA" };
            setVersionSelected(other);
            setFormData(prev => ({ ...prev, version: "OTRA" }));
            if (setVersion) {
                setVersion({ id: -1, label: "OTRA" });
            }
            return;
        }

        const versionFound = versionsNormalized.find((item: any) => item?.id === parsedId);
        if (versionFound) {
            setVersionSelected(versionFound);
            setFormData(prev => ({ ...prev, version: versionFound.name }));
            if (setVersion) {
                setVersion({ id: versionFound.id, label: versionFound.name });
            }
        }
    }

    const handleChangeType = (value: string) => {
        const vehicleTypeNormalized = TYPE_TYPES.find(
            type => type.value.toUpperCase() === value.toUpperCase()
        )?.value;

        if (vehicleTypeNormalized) {
            setTypeSelected(vehicleTypeNormalized);
            setFormData(prev => ({ ...prev, carroceria: vehicleTypeNormalized }));

            // Siempre actualizar el tipo en el estado global
            if (setType) {
                setType(vehicleTypeNormalized);
            }
        }
    }

    const handleChangeTransmission = (value: string) => {
        setTransmissionSelected(value);
        setFormData(prev => ({ ...prev, transmision: value }));

        // IMPORTANTE: Detail usa capitalize(salePost?.transmission)
        // Siempre actualizar la transmisión en el estado global
        if (setTransmission) {
            setTransmission(value);
        }
    }

    const onPressNext = (model: any) => {
        // Obtener el año seleccionado
        const yearValue = formData.añoInt || (formData.año ? parseInt(formData.año) : null);

        // Guardar todos los valores en estados globales
        // Implementación similar a CarDetail.onPressNext
        setVersion({ id: versionSelected.id, label: versionSelected.name });

        // Asegurarse de que el tipo de carrocería se actualice correctamente
        if (setType && typeSelected) {
            setType(typeSelected);
        } else if (setType && vehicleType) {
            setType(vehicleType);
        }

        // Asegurarse de que la transmisión se actualice correctamente
        if (setTransmission && transmissionSelected) {
            setTransmission(transmissionSelected);
        } else if (setTransmission && transmission) {
            setTransmission(transmission);
        } else if (setTransmission) {
            setTransmission(TRANSMISSION_TYPES[0]);
        }
        setRegion(regionSelected);
        setColor(colorSelected.toLowerCase());
        setFuel(fuelSelected.toLowerCase());
        setDoors(parseInt(doorsSelected));
        setModel({ id: model.id, label: model.name });

        if (setYear && yearValue) {
            setYear(yearValue);
        }

        if (setKms && mileage?.value) {
            const kmValue = mileage.value.replace(/\./g, '');
            setKms(kmValue);
        }

        updateRecord('all', '');

        // Obtener precio sugerido basado en los datos ingresados
        // Esto es crucial para que el componente Price pueda mostrar correctamente el rango de precios
        const priceParams = {
            brand_id: brandSelected?.id,
            model_id: modelSelected?.id,
            version_id: versionSelected?.id,
            km: mileage?.value?.replace(/\./g, '') || '',
            year: yearValue
        };


        // Añadir request_id si existe
        if (request_id) {
            getSuggestedPrice({ ...priceParams, request_id });
        } else {
            getSuggestedPrice(priceParams);
        }
        localStorage.setItem('linzeFormData', JSON.stringify(formData));
        // Continuar al siguiente paso
        if (onContinue) {
            onContinue();
        }
    };

    useEffect(() => {
        const savedForm = localStorage.getItem('linzeFormData');
        const fromRoute = location.state?.from;
        if (savedForm && fromRoute === '/sell/detail') {
            const parsed = JSON.parse(savedForm);

            setFormData(parsed);
            // También podés setear los estados locales si querés, ej:
            setVersionSelected({ id: parsed.version === 'OTRA' ? -1 : null, name: parsed.version });
            setFuelSelected(parsed.combustible);
            setTransmissionSelected(parsed.transmision);
            setTypeSelected(parsed.carroceria);
            setColorSelected(parsed.color);
            setDoorsSelected(parsed.puertas);
            setMileage({ value: addPointsInText(parsed.kilometraje), error: '' });
            setRegionSelected(parsed.region);
        }
    }, []);
    // Inicializar valores cuando se monta el componente
    useEffect(() => {
        // Inicializar valores locales desde props
        if (kms) {
            // Solo mostrar si no es cero
            if (kms !== "0") {
                const { formattedNumber } = formatInput(kms);
                setMileage({ value: formattedNumber, error: "" });
                setFormData(prev => ({ ...prev, kilometraje: kms }));
            } else {
                // Si es cero, dejar el campo vacío
                setMileage({ value: "", error: "" });
                setFormData(prev => ({ ...prev, kilometraje: "" }));
            }
        }
        if (transmission) setTransmissionSelected(transmission);
        if (fuel) setFuelSelected(fuel);
        if (vehicleType) setTypeSelected(vehicleType);
        if (doors) {
            setDoorsSelected(doors.toString());
            setFormData(prev => ({ ...prev, puertas: doors.toString() }));
        }

        // Inicializar datos de registro
        setAccidentsReported({ ...accidentsReportedState, value: accidentsReported });
        setPersonalUse({ ...personalUseState, value: personalUse });
        setSoleOwner({ ...soleOwnerState, value: soleOwner });
        if (region) setRegionSelected(region);

    }, []);

    // Efecto para sincronizar valores con el estado global
    useEffect(() => {
        // Actualizar kilómetros
        if (setKms && mileage?.value) {
            setKms(mileage.value.replace(/\./g, ''));
        }

        // Actualizar transmisión
        if (setTransmission && transmissionSelected) {
            setTransmission(transmissionSelected);
        }

        // Actualizar combustible
        if (setFuel && fuelSelected) {
            setFuel(fuelSelected.toLowerCase());
        }

        // Actualizar registro
        updateRecord('all', '');
    }, [mileage?.value, transmissionSelected, fuelSelected, accidentsReportedState?.value, personalUseState?.value, soleOwnerState?.value]);


    // Función para manejar cambios en los campos del formulario
    const handleChange = (field: string) => (event: any) => {
        const value = event.target.value;

        // Validación para kilometraje
        if (field === 'kilometraje') {
            const kmValue = parseInt(value);
            if (kmValue <= 0) {
                return;
            }
        }

        // Actualizar el formulario local
        setFormData({
            ...formData,
            [field]: value
        });

        // Actualizar estados globales según el campo
        switch (field) {
            case 'color':
                if (COLORS.includes(value)) {
                    setColor(value.toLowerCase());
                }
                break;
            case 'combustible':
                if (FUEL_TYPES.includes(value)) {
                    setFuel(value.toLowerCase());
                }
                break;
            case 'transmision':
                setTransmission(value);
                break;
            case 'tipo':
                setType(value);
                break;
        }
    };

    const brandsNormalized: any = useMemo(() => {
        return brands?.data && brands?.data.map((brand: any) => (
            {
                id: brand?.brand_id,
                name: brand?.name
            }
        ))
    }, [brands?.data]);

    const modelsNormalized: any = useMemo(() => {
        return models?.data && models?.data.map((model: any) => (
            {
                id: model?.model_id,
                name: model?.name
            }
        ))
    }, [models?.data]);

    const regionsNormalized: any = useMemo(() => {
        return regions && regions.map((region: any) => ({
            id: region.region_id,
            name: region.name
        }));
    }, [regionsData]);
    const versionsNormalized: any = useMemo(() => {
        const normalized = versions
            ?.filter((version: any) => version?.name?.toLowerCase() !== "otra") // filtramos duplicados
            .map((version: any) => ({
                id: version?.version_id,
                name: version?.name
            })) || [];

        return [...normalized, { id: -1, name: "OTRA" }];
    }, [versions]);

    const typesNormalized: any = useMemo(() => {
        return TYPE_TYPES && TYPE_TYPES.map((type: any) => (
            {
                id: type?.id,
                name: type?.value,
                value: type?.value
            }
        ))
    }, [TYPE_TYPES]);

    const transmissionsNormalized: any = useMemo(() => {
        return TRANSMISSION_TYPES && TRANSMISSION_TYPES.map((transmission: any, index: number) => (
            {
                id: index,
                name: transmission,
                value: transmission
            }
        ))
    }, [TRANSMISSION_TYPES]);


    const fuelsNormalized: any = useMemo(() => {
        return FUEL_TYPES && FUEL_TYPES.map((fuel: any, index: number) => (
            {
                id: index,
                name: capitalize(fuel),
                value: fuel
            }
        ))
    }, [FUEL_TYPES]);


    // Cargar marcas al montar el componente
    useEffect(() => {
        if (getBrands) {
            getBrands();
        }
    }, []);


    const [versionsLoadedFromPatent, setVersionsLoadedFromPatent] = useState(false);

    useEffect(() => {
        if (!isPatentFound || !initialData) return;

        // Marca y modelo
        if (initialData.brand_id && initialData.brand_name) {
            setBrand({ id: initialData.brand_id, label: initialData.brand_name });
            getModels?.(initialData.brand_id);
        }
        if (initialData.model_id && initialData.model_name) {
            setModel({ id: initialData.model_id, label: initialData.model_name });
        }

        // Versión
        if (initialData.version_id && initialData.version_name) {
            setVersion({ id: initialData.version_id, label: initialData.version_name });
            setVersionSelected({ id: initialData.version_id, name: initialData.version_name });
        }

        if (initialData.transmission) {
            setTransmissionSelected(capitalize(initialData.transmission) || "");
            setTransmission(transmissionSelected);
        }

        // Combustible
        if (initialData.fuel) {
            setFuelSelected(capitalize(initialData.fuel) || "");
        }

        // Color con fallback
        if (initialData.color) {
            const parsedColor = initialData.color.split(" ")[0].toLowerCase();
            const match = COLORS.find((c) => c.toLowerCase().includes(parsedColor));
            setColorSelected(match || "OTRO");
        }

        if (initialData?.vehicle_type !== undefined && initialData?.vehicle_type !== null) {
            const vehicleTypeTrimmed = initialData.vehicle_type.trim();
            if (vehicleTypeTrimmed === "") {
                // Si viene vacío, se asigna cadena vacía
                setTypeSelected("");
                setFormData(prev => ({
                    ...prev,
                    carroceria: ""
                }));
            } else {
                // Si viene un valor, se intenta buscar en la lista de opciones
                const parsedType = vehicleTypeTrimmed.toLowerCase();
                const matchedType = TYPE_TYPES.find(
                    t => t.value.trim().toLowerCase() === parsedType
                );
                // Si coincide, se asigna ese valor; si no, se asigna "Otro"
                const finalValue = matchedType ? matchedType.value : "Otro";
                setTypeSelected(finalValue);
                setFormData(prev => ({
                    ...prev,
                    carroceria: finalValue
                }));
            }
        }


        // Versiones
        if (initialData.model_id && initialData.year) {
            getVersions?.({ model_id: initialData.model_id, year: initialData.year });
        }

    }, [isPatentFound, initialData]);



    // Obtener modelos cuando se selecciona una marca (solo si no se encontró patente)
    useEffect(() => {
        if (!isPatentFound && brands?.selected?.id && getModels) {
            getModels(brands.selected.id);
        }
    }, [isPatentFound, brands?.selected?.id, getModels]);

    // Obtener versiones cuando se selecciona un modelo y año (solo si no se encontró patente)
    useEffect(() => {
        if (!isPatentFound && modelSelected?.id && formData.año && getVersions) {
            getVersions({
                model_id: modelSelected.id,
                year: parseInt(formData.año)
            });
        }
    }, [isPatentFound, modelSelected?.id, formData.año, getVersions]);


    // Este efecto se ha movido al efecto de inicialización

    // Actualizar color seleccionado cuando cambia el color global
    useEffect(() => {
        const colorFound = COLORS.find((item: any) => item === color);
        if (colorFound) {
            const capitalizedColor = capitalize(colorFound);
            if (capitalizedColor) setColorSelected(capitalizedColor);
        }
    }, [color, COLORS]);

    // Validar campos requeridos para habilitar/deshabilitar el botón de continuar
    useEffect(() => {
        const requiredFieldsValid = (
            // Datos básicos del vehículo
            typeSelected && TYPE_TYPES.find((type) => typeSelected === type?.value) &&
            formData.año &&
            brandSelected?.id &&
            modelSelected?.id &&
            versionSelected?.id &&
            colorSelected &&
            fuelSelected &&
            transmissionSelected &&

            // Datos de uso y estado
            personalUseState?.value &&
            accidentsReportedState?.value &&
            soleOwnerState?.value &&
            regionSelected &&
            // Kilometraje válido (mayor a 0)
            mileage?.value && parseInt(mileage.value.replace(/\./g, '')) > 0
        );

        const requiredFieldsValidNewCar = (
            // Datos básicos del vehículo
            typeSelected && TYPE_TYPES.find((type) => typeSelected === type?.value) &&
            formData.año &&
            brandSelected?.id &&
            modelSelected?.id &&
            versionSelected?.id &&
            colorSelected &&
            fuelSelected &&
            transmissionSelected &&
            regionSelected 
        );

        if (location.state?.type !== 'new-car') {
            setDisabled(!requiredFieldsValid);
        }

        if (location.state?.type === 'new-car') {
            setDisabledNewCar(!requiredFieldsValidNewCar);
        }

        if (onValidityChange) {
            if (location.state?.type === 'new-car') {
                onValidityChange(requiredFieldsValidNewCar);
            } else {
                onValidityChange(requiredFieldsValid);
            }
        }
    }, [
        typeSelected,
        formData.año,
        brandSelected?.id,
        modelSelected?.id,
        versionSelected?.id,
        colorSelected,
        personalUseState?.value,
        accidentsReportedState?.value,
        mileage?.value,
        soleOwnerState?.value,
        fuelSelected,
        transmissionSelected,
        regionSelected,
        onValidityChange
    ]);


    // Actualizar estados de registro cuando cambian las props
    useEffect(() => {
        if (accidentsReported) setAccidentsReported({ value: accidentsReported, error: "" });
        if (personalUse) setPersonalUse({ value: personalUse, error: "" });
        if (soleOwner) setSoleOwner({ value: soleOwner, error: "" });
    }, [accidentsReported, personalUse, soleOwner]);

    const handleBrandChange = (brandId: number) => {
        const selectedBrand = brandsNormalized?.find((brand: any) => brand.id === brandId);

        if (selectedBrand) {
            // Actualizar estado local de la marca y limpiar los valores de modelo y versión
            setBrandSelected(selectedBrand);
            setFormData(prev => ({
                ...prev,
                marca: selectedBrand.name,
                // Limpiamos las propiedades de modelo y versión del formulario
                modelo: "",
                version: ""
            }));

            // Limpiar modelos y versiones usando las funciones clean (si están definidas)
            if (cleanGetModels) cleanGetModels();
            if (cleanGetVersions) cleanGetVersions();

            // Resetear los estados locales de modelo y versión para que no se muestre ningún check
            setModelSelected({ id: null, name: null });
            setVersionSelected({ id: null, name: null });

            // Actualizar estado global de la marca
            if (setBrand) setBrand({ id: selectedBrand.id, label: selectedBrand.name });

            // Obtener nuevos modelos para la marca seleccionada
            if (getModels) getModels(brandId);
        }
    };


    const handleModelChange = (modelId: number) => {
        const selectedModel = modelsNormalized?.find((model: any) => model.id === modelId);

        if (selectedModel) {
            // Actualizar estado local
            setModelSelected(selectedModel);
            setFormData(prev => ({ ...prev, modelo: selectedModel.name, version: "" }));

            // Limpiar versiones usando la función clean
            if (cleanGetVersions) cleanGetVersions();
            setVersionSelected({ id: null, name: null });

            // Actualizar estado global
            if (setModel) setModel({ id: selectedModel.id, label: selectedModel.name });

            // Obtener versiones si hay año seleccionado
            if (formData.año && getVersions) {
                getVersions({
                    model_id: modelId,
                    year: parseInt(formData.año)
                });
            }
        }
    };

    const handleYearChange = (yearValue: string) => {
        const yearInt = parseInt(yearValue);

        // Actualizar el formData: asignar el nuevo año y limpiar el campo "version"
        setFormData(prev => ({
            ...prev,
            año: yearValue,
            añoInt: yearInt,
            version: ""
        }));

        if (cleanGetVersions) cleanGetVersions();
        // Resetear el estado local de la versión, para que el check desaparezca
        setVersionSelected({ id: null, name: null });

        // Actualizar el estado global del año
        if (setYear) {
            setYear(yearInt);
        }

        // Si hay modelo seleccionado, obtener las nuevas versiones para el año
        if (modelSelected?.id && getVersions) {
            getVersions({
                model_id: modelSelected.id,
                year: yearInt,
            });
        }
    };


    useEffect(() => {
        const savedForm = localStorage.getItem('linzeFormData');
        if (savedForm) {
            const parsed = JSON.parse(savedForm);
            setFormData(parsed);

            // 🔍 Buscar por nombre en las marcas normalizadas
            const brandMatch = brands?.data?.find((b: { brand_id: number; name: string }) => b.name === parsed.marca);
            if (brandMatch) {
                setBrandSelected({ id: brandMatch.brand_id, name: brandMatch.name });
                if (setBrand) setBrand({ id: brandMatch.brand_id, label: brandMatch.name });
                if (getModels) getModels(brandMatch.brand_id);
            }

            // 🔍 Buscar por nombre en los modelos normalizados
            const modelMatch = models?.data?.find((m: { model_id: number; name: string }) => m.name === parsed.modelo);
            if (modelMatch) {
                setModelSelected({ id: modelMatch.model_id, name: modelMatch.name });
                if (setModel) setModel({ id: modelMatch.model_id, label: modelMatch.name });

                // Si además hay año, traigo versiones
                if (parsed.añoInt && getVersions) {
                    getVersions({ model_id: modelMatch.model_id, year: parsed.añoInt });
                }
            }

            if (parsed.version === "OTRA") {
                setVersionSelected({ id: -1, name: "OTRA" });
                if (setVersion) setVersion({ id: -1, label: "OTRA" });
            } else {
                const versionMatch = versions?.find(v => v.name === parsed.version);
                if (versionMatch) {
                    setVersionSelected({ id: versionMatch.version_id, name: versionMatch.name });
                    if (setVersion) setVersion({ id: versionMatch.version_id, label: versionMatch.name });
                }
            }

            // Combustible, transmisión, etc.
            setFuelSelected(parsed.combustible);
            setTransmissionSelected(parsed.transmision);
            setTypeSelected(parsed.carroceria);
            setColorSelected(parsed.color);
            setDoorsSelected(parsed.puertas);
            setMileage({ value: addPointsInText(parsed.kilometraje), error: '' });

            if (parsed.usoPersonal) setPersonalUse({ value: parsed.usoPersonal, error: '' });
            if (parsed.accidentesReportados) setAccidentsReported({ value: parsed.accidentesReportados, error: '' });
            if (parsed.unicoDueño) setSoleOwner({ value: parsed.unicoDueño, error: '' });

        }
    }, [brands?.data, models?.data, versions]);

    useEffect(() => {
        const savedForm = localStorage.getItem('linzeFormData');
        const fromRoute = location.state?.from;

        if (fromRoute !== '/sell/detail' && savedForm) {
            localStorage.removeItem('linzeFormData');
        }
    }, [location.state?.from]);

    return (
        <div className={styles.basicInfoContainer}>
            <div className={styles.formSection}>
                <div className={styles.alertMessage}>
                    <p>
                        {isPatentFound
                            ? "Verifica que los datos reconocidos sean correctos y completa los que faltan. Mientras más datos brindes, tu publicación se posicionará mejor. Los campos con * son obligatorios."
                            : "Completa los campos con la información de tu vehículo. Mientras más datos brindes, tu publicación se posicionará mejor. Los campos con * son obligatorios."}
                    </p>
                </div>


                <div className={styles.formGrid}>
                    <TextField
                        select
                        required
                        label="Carrocería"
                        value={typeSelected || ''}
                        sx={sxTextFieldDefault}
                        onChange={(e) => handleChangeType(e.target.value)}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                typeSelected ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {typesNormalized?.map((type: any) => (
                            <MenuItem key={type.id} value={type.value}>
                                {type.name}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        select
                        required
                        label="Año"
                        value={formData.año || ''}
                        sx={sxTextFieldDefault}
                        onChange={(e) => handleYearChange((e.target.value))}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                formData.año ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {yearsNormalized.map((year) => (
                            <MenuItem key={year.id} value={year.id}>{year.name}</MenuItem>
                        ))}
                    </TextField>


                    <TextField
                        select
                        required
                        label="Marca"
                        value={brandSelected?.id || ''}
                        sx={sxTextFieldDefault}
                        onChange={(e) => handleBrandChange(parseInt(e.target.value))}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                brandSelected?.id ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {brandsNormalized?.map((brand: any) => (
                            <MenuItem key={brand.id} value={brand.id}>
                                {brand.name}
                            </MenuItem>
                        ))}
                    </TextField>


                    <TextField
                        className={styles.fullWidth}
                        select
                        required
                        label="Modelo"
                        sx={sxTextFieldDefault}
                        value={modelSelected?.id || ''}
                        onChange={(e) => handleModelChange(parseInt(e.target.value))}
                        disabled={!brandSelected?.id}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                modelSelected?.id ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {modelsNormalized?.map((model: any) => (
                            <MenuItem key={model.id} value={model.id}>
                                {model.name}
                            </MenuItem>
                        ))}
                    </TextField>


                    <TextField
                        className={styles.fullWidth}
                        select
                        required
                        label="Versión"
                        sx={sxTextFieldDefault}
                        value={versionSelected?.id || ''}
                        onChange={(e) => handleChangeVersion(e.target.value)}
                        disabled={!modelSelected?.id || !formData.año}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                versionSelected?.id ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {versionsNormalized?.map((version: any) => (
                            <MenuItem key={version.id} value={version.id}>
                                {version.name}
                            </MenuItem>
                        ))}
                    </TextField>


                    <TextField
                        select
                        required
                        label="Color"
                        sx={sxTextFieldDefault}
                        value={colorSelected?.toLowerCase() || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            setColorSelected(value);
                            setFormData((prev) => ({ ...prev, color: value }));
                        }}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                colorSelected ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {COLORS.map((color, index) => (
                            <MenuItem key={index} value={color}>
                                {capitalize(color)}
                            </MenuItem>
                        ))}
                    </TextField>


                    <TextField
                        select
                        required
                        label="Transmisión"
                        sx={sxTextFieldDefault}
                        value={transmissionSelected}
                        onChange={(e) => handleChangeTransmission(e.target.value)}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                transmissionSelected ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {transmissionsNormalized?.map((transmission: any) => (
                            <MenuItem key={transmission.id} value={transmission.value}>
                                {transmission.name}
                            </MenuItem>
                        ))}
                    </TextField>


                    <TextField
                        select
                        required
                        label="Combustible"
                        value={fuelSelected}
                        sx={sxTextFieldDefault}
                        onChange={(e) => {
                            const value = e.target.value;
                            setFuelSelected(value);
                            setFormData((prev) => ({ ...prev, combustible: value }));
                            if (setFuel) {
                                setFuel(value.toLowerCase());
                            }
                        }}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                fuelSelected ? (
                                    <Box sx={customIconStyle}>
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {fuelsNormalized?.map((fuel: any) => (
                            <MenuItem key={fuel.id} value={fuel.value}>
                                {fuel.name}
                            </MenuItem>
                        ))}
                    </TextField>


                </div>
                <div className={styles.twoColumnGrid}>
                    {location.state?.type !== 'new-car' ? (
                        <TextField
                            required
                            label="Kilometraje"
                            placeholder="Ej: 50.000"
                            value={mileage?.value}
                            onChange={onChangeMileage}
                            onBlur={onBlurMileage}
                            fullWidth
                            error={!!mileage?.error}
                            helperText={mileage?.error || ''}
                            sx={sxTextFieldDefault}
                            InputProps={{
                                endAdornment:
                                    mileage?.value && parseInt(mileage.value.replace(/\./g, '')) > 0 ? (
                                        <Box
                                            sx={{
                                                width: 10,
                                                height: 10,
                                                border: '1px solid green',
                                                padding: 0.5,
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                        </Box>
                                    ) : (
                                        <span style={{ color: '#666666' }}>Km</span>
                                    )
                            }}
                        />
                    ) : (
                        <TextField
                            select
                            label="Región"
                            required
                            value={regionSelected}
                            onChange={handleChangeRegion}
                            fullWidth
                            sx={sxTextFieldDefault}
                            SelectProps={{
                                ...selectProps,
                                IconComponent: (props) =>
                                    regionSelected
                                        ? (
                                            <Box
                                                sx={{
                                                    width: 10,
                                                    height: 10,
                                                    border: '1px solid green',
                                                    padding: 0.5,
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    marginRight: 2,
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                            </Box>
                                        )
                                        : <ArrowDropDownIcon {...props} />,
                            }}
                        >
                            {REGION_NAMES.map((option: any) => (
                                <MenuItem key={option.id} value={option.name}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}


                    <TextField
                        select
                        label="Puertas"
                        required
                        value={doorsSelected || ''}
                        onChange={(e) => {
                            const doorsValue = e.target.value;
                            setDoorsSelected(doorsValue);
                            setFormData((prev) => ({ ...prev, puertas: doorsValue }));
                            if (setDoors) {
                                const doorsInt = parseInt(doorsValue);
                                setDoors(doorsInt);
                            }
                        }}
                        fullWidth
                        sx={sxTextFieldDefault}
                        SelectProps={{
                            ...selectProps,
                            IconComponent: (props) =>
                                doorsSelected ? (
                                    <Box
                                        sx={{
                                            width: 10,
                                            height: 10,
                                            border: '1px solid green',
                                            padding: 0.5,
                                            borderRadius: '50%',
                                            display: 'flex',
                                            marginRight: 2,
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                    </Box>
                                ) : (
                                    <ArrowDropDownIcon {...props} />
                                ),
                        }}
                    >
                        {DOORS_OPTIONS.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>


                </div>
                {location.state?.type !== 'new-car' && (
                    <>
                        <p>Datos complementarios</p>
                        <div className={styles.twoColumnGrid}>
                            <TextField
                                select
                                label="Uso"
                                required
                                value={personalUseState?.value}
                                onChange={onChangePersonalUse}
                                fullWidth
                                sx={sxTextFieldDefault}
                                SelectProps={{
                                    ...selectProps,
                                    IconComponent: (props) =>
                                        personalUseState?.value
                                            ? (
                                                <Box
                                                    sx={{
                                                        width: 10,
                                                        height: 10,
                                                        border: '1px solid green',
                                                        padding: 0.5,
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        marginRight: 2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                                </Box>
                                            )
                                            : <ArrowDropDownIcon {...props} />,
                                }}
                            >
                                {optionsPersonalUse.map((option) => (
                                    <MenuItem key={option.id} value={option.name}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>


                            <TextField
                                select
                                required
                                label="Único dueño"
                                value={soleOwnerState?.value}
                                onChange={onChangeSoleOwner}
                                fullWidth
                                sx={sxTextFieldDefault}
                                SelectProps={{
                                    ...selectProps,
                                    IconComponent: (props) =>
                                        soleOwnerState?.value
                                            ? (
                                                <Box
                                                    sx={{
                                                        width: 10,
                                                        height: 10,
                                                        border: '1px solid green',
                                                        padding: 0.5,
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        marginRight: 2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                                </Box>
                                            )
                                            : <ArrowDropDownIcon {...props} />,
                                }}
                            >
                                {optionsSoleOwner.map((option) => (
                                    <MenuItem key={option.id} value={option.name}>
                                        {option.name === "Si" ? "Sí" : option.name}
                                    </MenuItem>
                                ))}
                            </TextField>


                        </div>

                        <div className={styles.twoColumnGrid}>
                            <TextField
                                select
                                label="Accidentes"
                                required
                                value={accidentsReportedState?.value}
                                onChange={onChangeAccidentsReported}
                                fullWidth
                                sx={sxTextFieldDefault}
                                SelectProps={{
                                    ...selectProps,
                                    IconComponent: (props) =>
                                        accidentsReportedState?.value
                                            ? (
                                                <Box
                                                    sx={{
                                                        width: 10,
                                                        height: 10,
                                                        border: '1px solid green',
                                                        padding: 0.5,
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        marginRight: 2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                                </Box>
                                            )
                                            : <ArrowDropDownIcon {...props} />,
                                }}
                            >
                                {optionsAccidentsReported.map((option) => (
                                    <MenuItem key={option.id} value={option.name}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>

                            <TextField
                                select
                                label="Región"
                                required
                                value={regionSelected}
                                onChange={handleChangeRegion}
                                fullWidth
                                sx={sxTextFieldDefault}
                                SelectProps={{
                                    ...selectProps,
                                    IconComponent: (props) =>
                                        regionSelected
                                            ? (
                                                <Box
                                                    sx={{
                                                        width: 10,
                                                        height: 10,
                                                        border: '1px solid green',
                                                        padding: 0.5,
                                                        borderRadius: '50%',
                                                        display: 'flex',
                                                        marginRight: 2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'

                                                    }}
                                                >
                                                    <CheckIcon sx={{ color: 'green', fontSize: 15 }} />
                                                </Box>
                                            )
                                            : <ArrowDropDownIcon {...props} />,
                                }}
                            >
                                {REGION_NAMES.map((option: any) => (
                                    <MenuItem key={option.id} value={option.name}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>
                    </>
                )}

                <div className={styles.featuresSection}>
                    <FeaturesList
                        getAdditionalCharacters={getAdditionalCharacters}
                        additionalCharacters={additionalCharacters}
                        selectedFeatures={selectedAdditionalCharacters}
                        setAdditionalCharacters={setAdditionalCharacters}
                        setSelectedAdditionalCharacters={setSelectedAdditionalCharacters}
                    />
                </div>


            </div>
            <div className={location.state?.type === 'new-car' ? styles.imageSectionNewCar : styles.imageSection}>
                <img src={images.linzeFlujoPublicacion} alt="Linze Keys" />
                <div className={styles.buttonContainer}>

                    <Button
                        onPress={() => {
                            onPressNext(modelSelected);
                        }}
                        title="Continuar"
                        primary
                        disabled={location.state?.type === 'new-car' ? disabledNewCar : location.state?.type === 'used-car' ? disabled : true}
                        className={styles.submitButton}
                    />
                </div>
            </div>
        </div>
    );
};

export default BasicInfo;
